module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/icon_check-a39a57b1.png";